/* ------------------------------------------------------------------------ */
/*		File: cmpSteps.tsx                                                  */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICmpStep } from "./cmpStep.d";
import { getImage } from "../GenericComponents/functions";
import "./cmpStep.css";

/* ------------------------------------------------------------------------ */

const Step: React.FC<ICmpStep> = (props) => {
    return (
        <div className={`card_step  ${props.description!.length > 150 ? `card_step_top` : `card_step_center`} `}>
            <img 
                className={`card_step_image`} 
                src={getImage(props.src)} 
                alt={props.src} 
            />
            <div 
                className="card_step_description"
                dangerouslySetInnerHTML={{ __html: props.description! }}
            />
        </div>
    );
};

export default Step;